import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';

import './toast.component.scss';

/**
 * Toast Component
 * @param props
 */
class Toast extends Component {

    /**
     * Constructor
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            closed: {}
        };
    }

    /**
     * On toast close
     * @param id
     */
    onClose = (id) => {
        const {deleteToast} = this.props;

        this.setState({
            closed: Object.assign({}, this.state.closed, {
                [id]: true
            })
        });

        if (id && deleteToast) {
            deleteToast(id);
        }
    };

    /**
     * Renders a single toast notification.
     * @param message
     */
    renderToastMessage = (message) => {
        const {anchor, timeout, transition} = this.props;
        const {closed} = this.state;

        return (
            <Snackbar
                key={message.id}
                className='toast-item'
                anchorOrigin={anchor}
                autoHideDuration={timeout}
                resumeHideDuration={timeout}
                disableWindowBlurListener={true}
                TransitionProps={transition}
                open={!closed[message.id]}
                onClose={() => this.onClose(message.id)}>
                <div className='toast-item_content'>
                    <i className={`toast-item_icon ${message.type ? `toast-item_icon--${message.type}` : 'toast-item_icon--success'}`}></i>
                    <div className='toast-item_message'>{message.text}</div>
                    <i className='toast-item_close q4i-close-4pt' onClick={() => this.onClose(message.id)}></i>
                </div>
            </Snackbar>
        );

    };

    /**
     * Render Toast Component
     * @returns {*}
     */
    render() {
        const {message} = this.props;
        return (
            <div className='toast'>
                {message.map((message) => this.renderToastMessage(message))}
            </div>
        );
    }
}

Toast.propTypes = {
    anchor: PropTypes.shape({
        vertical: PropTypes.string,
        horizontal: PropTypes.string
    }),
    timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transition: PropTypes.shape({
        direction: PropTypes.string,
        timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    message: PropTypes.array.isRequired,
    deleteToast: PropTypes.func.isRequired
};

Toast.defaultProps = {
    anchor: {
        vertical: 'top',
        horizontal: 'right'
    },
    timeout: 3000,
    transition: {
        direction: 'left',
        timeout: 250
    },
    message: []
};

export default Toast;